import { useWorkspaceStore } from "../store/workspace/WorkspaceStore";
import { GlobalSettings } from "../types/globalSettings";

export const useGlobalSettings = (): GlobalSettings => {
  const configuration = useWorkspaceStore(
    (state) => state.draft?.configuration
  );
  return {
    competitorPresence: configuration?.competitorsProductIds || [],
    companyMatchFile: configuration?.whitespace ?? undefined,
    localizeInstalls: configuration?.localizeInstalls ?? true,
  };
};
